import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { clsx } from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';
import { UserIcon } from '../icons/react/user.tsx';
import {
  avatarFallback,
  avatarImage,
  avatarRoot,
  avatarRootSize,
  AvatarSize,
} from './avatar.css.ts';

export interface AvatarProps extends ComponentPropsWithoutRef<'span'> {
  imageSrc?: string | null;
  size?: AvatarSize;
}

export const Avatar: FC<AvatarProps> = ({
  className,
  size = 'small',
  imageSrc,
}) => (
  <AvatarPrimitive.Root
    className={clsx(avatarRoot, avatarRootSize[size], className)}
  >
    <AvatarPrimitive.Image
      className={avatarImage}
      src={imageSrc ?? undefined}
      alt={'Avatar'}
    />
    <AvatarPrimitive.Fallback
      delayMs={imageSrc ? 600 : 0}
      className={avatarFallback}
    >
      <UserIcon width={'100%'} height={'100%'} />
    </AvatarPrimitive.Fallback>
  </AvatarPrimitive.Root>
);
